import { createContext, useContext, useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { AuthContext } from "./AuthContext";

export const SocketContext = createContext();

export const SocketProvider = ({ children }) => {
    const { userId } = useContext(AuthContext);
    const socket = useRef(null);

    useEffect(() => {
        if (!userId) return;
        
        if (userId && !socket.current) {
            socket.current = io(process.env.REACT_APP_API_BASE); // ✅ your backend
            socket.current.emit("join", userId);
            console.log("🔌 Connected to socket server");
        }

        if (socket.current) {
            socket.current.on("connect", () => {
                console.log("✅ Socket is connected");
            });
        }

        return () => {
            if (socket.current) {
                socket.current.disconnect();
                socket.current = null;
                console.log("🔌 Socket disconnected");
            }
        };
    }, [userId]);

    return (
        <SocketContext.Provider value={socket}>
            {children}
        </SocketContext.Provider>
    );
};

export const useSocket = () => useContext(SocketContext);
